import { ToneChipProps } from '../types';
import { Chip, alpha, useTheme } from '@mui/material';

const ToneChip = ({ label, tone, icon }: ToneChipProps) => {
  const theme = useTheme();
  const color = theme.palette[tone].main;

  return (
    <Chip
      size="small"
      icon={icon}
      label={label}
      sx={{
        height: 28,
        fontWeight: 700,
        borderRadius: '999px',
        color,
        border: `1px solid ${alpha(color, theme.palette.mode === 'dark' ? 0.45 : 0.35)}`,
        bgcolor: alpha(color, theme.palette.mode === 'dark' ? 0.18 : 0.1),
        '& .MuiChip-icon': {
          color,
        },
      }}
    />
  );
};

export default ToneChip;
